export default __webpack_public_path__ + "049d6296fa4324c5b651253f4928467b.png";